module.exports = __webpack_public_path__ + "static/blue-25bd0686c2f9170f7904043a055c9489.svg";